module.exports = __webpack_public_path__ + "static/img/sh30.f2a13f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/sh30.png
// module id = QwT+
// module chunks = 37